export const phoneNumberRegex = /^[0-9]{3,}$/;
